import { Link } from "lucide-react";
import { useState } from "react";
import { toast } from "react-toastify";
import useClipboard from "react-use-clipboard";

const CopyLinkButton = ({ endPoint }: { endPoint: string }) => {
  const linkUrlClipboard = `https://flipflop.maxx4business.com/${endPoint}`;
  const [isCopied, setCopied] = useClipboard(linkUrlClipboard, {
    successDuration: 2000,
  });
  const [color, setColor] = useState<any>(false);
  const handleCopy = () => {
    setColor(true);
    setCopied();
  };
  return (
    <div
      className={`flex w-8 h-8 rounded-full  text-center items-center justify-center cursor-pointer  ${
        color ? "bg-yellow-200 " : " bg-gray-200"
      }`}
      onClick={handleCopy}
    >
      <Link className={`size-5 text-black`} onClick={handleCopy} />
    </div>
  );
};

export default CopyLinkButton;
